module.exports = __webpack_public_path__ + "static/move_heatmap_login-3ad1d422c428ac2969b6c521072fd13f.jpg";